import { ServerTypeHelper } from '../helpers';
import geoCSVReader from '../../_assets/js/geoCSVReader';

const geoWorkspace = 'zcm';
const geoserverRoot = 'https://pedea.sema.ce.gov.br/geoserver';
const serverType = ServerTypeHelper.GEOSERVER;
const geoserverUrl = `${geoserverRoot}/`;
let capsAttrMap = {};



var csvData = "";//zcmData;

function normalizeGmlType(rawType) {
  if (!rawType) return '';
  let t = rawType.trim();

  // remove namespace (ex.: gml:)
  t = t.replace(/^[a-zA-Z0-9_]+:/, '');

  // remove sufixos bem comuns (PropertyType/Type/Property)
  t = t.replace(/PropertyType$/i, '')
       .replace(/Type$/i, '')
       .replace(/Property$/i, '');

  // padroniza maiúsculas/minúsculas
  return t; // ex.: "Point", "MultiSurface", "MultiLineString", "Surface", "Curve"
}

function mapGmlToFineGeometry(rawType){
  const t = normalizeGmlType(rawType);

  if (t === 'Point')               return 'Point';
  if (t === 'MultiPoint')          return 'MultiPoint';

  if (t === 'LineString')          return 'LineString';
  if (t === 'MultiLineString')     return 'MultiLineString';
  if (t === 'Curve' || t === 'MultiCurve') return 'LineString'; // GeoServer às vezes usa Curve

  if (t === 'Polygon')             return 'Polygon';
  if (t === 'MultiPolygon')        return 'MultiPolygon';
  if (t === 'Surface' || t === 'MultiSurface') return 'Polygon'; // Surface ~ Polygon

  if (t === 'Geometry' || t === 'GeometryCollection') return 'Unknown';

  return 'Unknown';
}

function mapGmlToSimpleCategory(rawType){
  switch (mapGmlToFineGeometry(rawType)) {
    case 'Point':
    case 'MultiPoint':
      return 'Point';
    case 'LineString':
    case 'MultiLineString':
      return 'Line';
    case 'Polygon':
    case 'MultiPolygon':
      return 'Polygon';
    default:
      return 'Unknown';
  }
}

async function getLayerAttributes(layerName) {
  try {
    const url = `${geoserverRoot}/${geoWorkspace}/ows?service=WFS&version=1.1.0&request=DescribeFeatureType&typeName=${geoWorkspace}:${layerName}`;
    const resp = await fetch(url);
    const txt = await resp.text();
    const xml = new DOMParser().parseFromString(txt, 'text/xml');

    const elements = [
      ...xml.getElementsByTagName('xsd:element'),
      ...xml.getElementsByTagName('element'),
    ];

    const attrs = [];
    let geomType = '';

    for (const el of elements) {
      const name = el.getAttribute('name');
      const type = (el.getAttribute('type') || '').replace(/^xsd:/, '');

      

      if (!name) continue;

      if (name === 'geom') {
        
        geomType = mapGmlToSimpleCategory(type);
        continue;
      }
      if (name === layerName) continue;

      attrs.push(`${name}:${type}`);
    }

    
    return {
      wfsAttributes: attrs.length ? `${attrs.join(',')},` : '',
      wfsGeometryType: geomType,
    };
  } catch (e) {
    console.warn(`DescribeFeatureType falhou para ${layerName}`, e);
    return { wfsAttributes: '', wfsGeometryType: '' };
  }
}

async function getCapabilitiesMap(geoserverRoot, workspace) {
  const capsURL = `${geoserverRoot}/${workspace}/ows?service=WMS&version=1.1.0&request=GetCapabilities`;
  const resp = await fetch(capsURL);
  const txt = await resp.text();
  const xml = new DOMParser().parseFromString(txt, 'text/xml');

  const keyMap = {};

  const layerNodes = xml.getElementsByTagName('Layer');
  for (let i = 0; i < layerNodes.length; i++) {
    const node = layerNodes[i];
    const name = node.getElementsByTagName('Name')[0]?.textContent || '';
    if (!name || name === 'GeoServer Web Map Service') continue;

    const bb = node.getElementsByTagName('BoundingBox')[0];
    const bbox = bb
      ? `${bb.getAttribute('minx')},${bb.getAttribute('miny')},${bb.getAttribute('maxx')},${bb.getAttribute('maxy')}`
      : '';

    keyMap[name] = { bbox, attributes: '', geometryType: '' };
  }

  const names = Object.keys(keyMap);
  
  /*for (const n of names) {
    const { attributes, geometryType } = await getLayerAttributes(geoserverRoot, workspace, n);
    keyMap[n].attributes = attributes;
    keyMap[n].geometryType = geometryType;
  }*/

  return keyMap;
}

function jsonToGeoCSV(dataArray) {
  return dataArray.map(item => {
    const id = item.id || '';
    const categoria = item.categoria_de_informacao || '';
    const classeMaior = item.classe_maior || '';
    const subClasseMaior = item.sub_classe_maior || '';
    const classeMenor = item.classe_menor || '';
    const nomenclatura = item.nomenclatura_greencloud || '';
    const nomeCamada = item.nomenclatura_pedea || '';
    const fonte = item.fonte || '';
    const atributo = item.coluna_atributo || '';
    const modulo_grafico = item.modulos_de_graficos ? 'Sim' : 'Não';
    const exibir = item.exibir_camada ? 'Sim' : 'Não';

    const meta = capsAttrMap[nomenclatura.toLowerCase()] || {};
    const bbox = meta.bbox || '';
    const attributes = meta.attributes || '';
    const geometryType = meta.geometryType || '';

    //if(id == )
    //console.log(`${id};${categoria};${classeMaior};${subClasseMaior};${classeMenor};${nomenclatura};${nomeCamada};${fonte};${atributo};${modulo_grafico};${exibir};${bbox};${attributes};${geometryType}`)

    return `${id};${categoria};${classeMaior};${subClasseMaior};${classeMenor};${nomenclatura};${nomeCamada};${fonte};${atributo};${modulo_grafico};${exibir};${bbox};${attributes};${geometryType}`;
  }).join('\n');
}

async function loadZcmData() {
    try {
        const response = await fetch('https://pedea.sema.ce.gov.br/gestor-api/infoDataExplorer');
        const jsonData = await response.json();


        if (Array.isArray(jsonData) && jsonData.length > 0) {
            csvData = jsonToGeoCSV(jsonData);

            
        } else {
            console.warn('Resposta vazia ou malformada da API. Usando fallback estático.');
        }
    } catch (error) {
        console.error('Erro ao carregar dados da API InfoDataExplorer. Usando fallback.', error);
    }

    document.getElementById('preloader').style.display = 'none';

}

 await getCapabilitiesMap(geoserverRoot, geoWorkspace).then(m => {
        capsAttrMap = m || {};
    });

await loadZcmData();

const { tree, layers } = geoCSVReader(csvData, geoWorkspace, geoserverUrl + geoWorkspace + '/wms', serverType);

export { layers, tree, geoWorkspace, geoserverUrl, getLayerAttributes };